import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: "100%"
    },
    title: {
      fontFamily: "Lato",
      fontSize: "1.75rem",
      color: "#54A4A6",
      fontWeight: "bold",
      fontStretch: "normal",
      fontStyle: "normal",
      letterSpacing: "normal",
      marginBottom: theme.spacing(2)
    },
    subTitle: {
      fontFamily: "Lato",
      fontSize: "1rem",
      fontStretch: "normal",
      fontStyle: "normal",
      letterSpacing: "normal",
      color: theme.palette.text.secondary
    },
    paper: {
      width: "100%",
      marginBottom: theme.spacing(2)
    },
    table: {
      minWidth: 750
    },
    visuallyHidden: {
      border: 0,
      clip: "rect(0 0 0 0)",
      height: 1,
      margin: -1,
      overflow: "hidden",
      padding: 0,
      position: "absolute",
      top: 20,
      width: 1
    },
    tableHead: {
      fontFamily: "Lato",
      color: "#54A4A6",
      fontWeight: "bold",
      fontStretch: "normal",
      fontStyle: "normal",
      letterSpacing: "normal",
      fontSize: "1rem"
    },
    statusImg: {
      boxSizing: "border-box",
      flex: "none",
      padding: "5px",
      width: "25px",
      height: "25px",
      minWidth: "25px",
      minHeight: "25px"
    },
    // Both branches of the Status cell share this box so the label starts at
    // the same x whether the row is editable or not.
    statusBox: {
      display: "flex",
      alignItems: "center",
      minHeight: "44px",
      paddingLeft: "8px",
      font: "inherit",
      color: "inherit"
    },
    statusButton: {
      padding: "0 0 0 8px",
      border: 0,
      background: "none",
      cursor: "pointer",
      width: "auto",
      "&:disabled": {
        cursor: "default",
        opacity: 0.6
      }
    },
    statusCaret: {
      marginLeft: "2px",
      fontSize: "1.5rem",
      color: "#6d6d6d"
    }
  })
);
